// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1a0e563f","900":"0174b9a4"}[chunkId] + ".chunk.js";
};